import React from 'react'
import styled, { css } from 'styled-components'

import { NavMenuLink, NavMenuLinkProps } from './nav-menu-link'
import { desktopViewQuery, mobileViewQuery } from './const'

type NavMenuLinkListProps = {
  titles: NavMenuLinkProps[]
}

const Container = styled.div`
  display: flex;

  ${(props) =>
    !props.theme.disableMobileQueries
      ? css`
          @media ${mobileViewQuery} {
            flex-direction: column;
            justify-content: space-evenly;
            align-items: center;
            background: none;
            height: 100%;
            font-size: 25px;
            font-weight: bold;
            opacity: 0.3;
          }
        `
      : ''}

  ${(props) =>
    !props.theme.disableMobileQueries
      ? css`
          @media ${desktopViewQuery} {
            justify-content: flex-end;
            color: white;
            font-size: 16px;
            flex: 2;
            margin: 0 20px;
            height: 100%;
          }
        `
      : css`
          justify-content: flex-end;
          color: white;
          font-size: 16px;
          flex: 2;
          margin: 0 20px;
          height: 100%;
        `}
`

export const NavMenuLinkList = ({ titles }: NavMenuLinkListProps) => {
  return (
    <Container>
      {titles.map(({ item, hasDropdown }, index) => (
        <NavMenuLink key={index} item={item} hasDropdown={hasDropdown} />
      ))}
    </Container>
  )
}
